"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => ({
  reactBusStops: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    minHeight: "80vh",
    [theme.breakpoints.up("md")]: {
      gap: theme.spacing(6)
    },
    "& .mco-bus-stops-towns + .mco-bus-stops-stations-by-town:before": {
      background: theme.palette.common.white,
      content: "''",
      display: "block",
      height: 2,
      left: 0,
      position: "absolute",
      right: 0,
      top: -18,
      [theme.breakpoints.up("md")]: {
        top: -38
      }
    },
    "& .mco-bus-stops-stations-by-town + .mco-bus-stops-lines-by-station:before": {
      background: theme.palette.common.white,
      content: "''",
      display: "block",
      height: 2,
      left: 0,
      position: "absolute",
      right: 0,
      top: -18,
      [theme.breakpoints.up("md")]: {
        top: -38
      }
    }
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    [theme.breakpoints.up("md")]: {
      gap: theme.spacing(6)
    }
  }
}));
var _default = exports.default = styles;